import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./nav.css";
import TokenService from "../services/token-service";
import logo from "../img/embroidery.png";

class Nav extends Component {
  logout = () => {
    TokenService.clearAuthToken();
  };
  render() {
    const token = TokenService.hasAuthToken();
    return (
      <header>
        <nav>
          <img
            className="embroidery-hands"
            src={logo}
            alt="hands holding embroidery"
          />
          <Link to="/">
            <li>Home</li>
          </Link>
          {!token ? (
            <>
              <Link to="/sign-up">
                <li>Sign Up</li>
              </Link>
              <Link to="/login">
                <li>Log In</li>
              </Link>
              <Link to="/about">
                <li>About</li>
              </Link>
            </>
          ) : (
            <>
              <Link to="/login" onClick={this.logout}>
                <li>Log Out</li>
              </Link>
              <Link to="/about">
                <li>About</li>
              </Link>
            </>
          )}
        </nav>
      </header>
    );
  }
}

export default Nav;
